export default __webpack_public_path__ + "static/media/elanePortrait.d573bae5.png";